(function(){
  var CHECKOUT_URL = 'https://meaikiyo.shop/cart/56905742385492:1';
  var R = document.getElementById('gr30');
  if(!R) return;
  var RD = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var co = R.querySelectorAll('.js-co');
  for (var i=0;i<co.length;i++) co[i].href = CHECKOUT_URL;

  var t = document.getElementById('grBar');
  if(t){ var b=t.innerHTML; t.innerHTML=b+b+b+b+b+b; }

  var ba=document.getElementById('grBa'), hint=document.getElementById('grHint'), touched=false;
  function setX(p){ if(ba) ba.style.setProperty('--x', Math.max(5, Math.min(95,p)) + '%'); }
  function evX(e){ var r=ba.getBoundingClientRect(); return ((e.touches?e.touches[0].clientX:e.clientX)-r.left)/r.width*100; }
  function mv(e){ setX(evX(e)); }
  if(ba){
    ba.addEventListener('pointerdown', function(e){
      touched=true;
      if(hint) hint.classList.add('off');
      setX(evX(e));
      window.addEventListener('pointermove', mv);
      window.addEventListener('pointerup', function(){ window.removeEventListener('pointermove', mv); }, {once:true});
    });
  }
  if(!RD && ba){
    setTimeout(function(){
      if(touched) return;
      var t0=performance.now(), D=2500;
      function ez(u){ return u<0.5 ? 4*u*u*u : 1-Math.pow(-2*u+2,3)/2; }
      (function st(now){
        if(touched) return;
        var u=Math.min(1,(now-t0)/D), x;
        if(u<=0.42) x=82+(16-82)*ez(u/0.42);
        else x=16+(50-16)*ez((u-0.42)/0.58);
        setX(x);
        if(u<1) requestAnimationFrame(st);
        else ba.classList.add('sh');
      })(t0);
    }, 700);
  }

  var scs=R.querySelectorAll('#grStk .sc');
  if(!RD){
    var tk=false;
    function loop(){
      tk=false;
      var vh=window.innerHeight;
      for(var i=0;i<scs.length-1;i++){
        var r=scs[i].getBoundingClientRect(), nr=scs[i+1].getBoundingClientRect();
        if(r.bottom<-40 || r.top>vh) continue;
        var p=Math.max(0, Math.min(1, 1-(nr.top-(40+i*13))/(r.height*0.92)));
        scs[i].style.setProperty('--s', 1-p*0.05);
        scs[i].style.setProperty('--b', (p*2.5)+'px');
        scs[i].style.setProperty('--o', p*0.28);
      }
      if(ba){
        var rb=ba.getBoundingClientRect();
        if(rb.bottom>0 && rb.top<vh){
          var c=(rb.top+rb.height/2-vh/2)/(vh/2);
          ba.style.setProperty('--rx', (Math.max(-1,Math.min(1,c))*5)+'deg');
        }
      }
    }
    window.addEventListener('scroll', function(){ if(!tk){ tk=true; requestAnimationFrame(loop); } }, {passive:true});
    loop();
  }

  function fmt(n,d){ return n.toLocaleString('en-GB', {minimumFractionDigits:d, maximumFractionDigits:d}); }
  function runCnt(el){
    var n=parseFloat(el.getAttribute('data-n')), dc=+(el.getAttribute('data-dec')||0);
    if(RD){ el.textContent=fmt(n,dc); return; }
    var t0=performance.now(), D=1600;
    (function st(now){
      var u=Math.min(1,(now-t0)/D), e=1-Math.pow(1-u,3);
      el.textContent=fmt(n*e,dc);
      if(u<1) requestAnimationFrame(st);
    })(t0);
  }
  var rvs=R.querySelectorAll('.rv');
  if(RD || !('IntersectionObserver' in window)){
    for(var i=0;i<rvs.length;i++) rvs[i].classList.add('on');
    var cnts=R.querySelectorAll('.cnt');
    for(var i=0;i<cnts.length;i++) runCnt(cnts[i]);
  } else {
    var io=new IntersectionObserver(function(es){
      for(var i=0;i<es.length;i++){
        if(!es[i].isIntersecting) continue;
        es[i].target.classList.add('on');
        if(es[i].target.id==='grStx'){
          var cnts=R.querySelectorAll('.cnt');
          for(var j=0;j<cnts.length;j++) runCnt(cnts[j]);
        }
        io.unobserve(es[i].target);
      }
    }, {threshold:0.16, rootMargin:'0px 0px -5% 0px'});
    for(var i=0;i<rvs.length;i++) io.observe(rvs[i]);
  }

  var allC=[], chats=R.querySelectorAll('#grChats .chat');
  for(var i=0;i<chats.length;i++) allC.push(chats[i]);
  for(var i=0;i<allC.length;i++){
    var bub=allC[i].querySelector('.cbub');
    if(bub) bub.insertAdjacentHTML('afterbegin','<span class="dots"><i></i><i></i><i></i></span>');
  }
  function seq(list){
    for(var i=0;i<list.length;i++){
      (function(c,idx){
        setTimeout(function(){ c.classList.add('av-in','typing'); }, idx*1050);
        setTimeout(function(){ c.classList.remove('typing'); c.classList.add('show'); }, idx*1050+680);
      })(list[i], i);
    }
  }
  if(RD || !('IntersectionObserver' in window)){
    for(var i=0;i<allC.length;i++) allC[i].classList.add('av-in','show');
  } else {
    var chatsEl=document.getElementById('grChats');
    if(chatsEl){
      var ioC=new IntersectionObserver(function(es){
        if(es[0].isIntersecting){
          seq(allC.slice(0,3));
          ioC.disconnect();
        }
      }, {threshold:0.3});
      ioC.observe(chatsEl);
    }
  }
  var more=document.getElementById('grMore'), ms=0;
  if(more){
    more.addEventListener('click', function(){
      ms++;
      var b=[], n=0;
      for(var i=0;i<allC.length && n<3;i++){
        if(allC[i].classList.contains('hid')){ b.push(allC[i]); n++; }
      }
      for(var i=0;i<b.length;i++) b[i].classList.remove('hid');
      if(RD){ for(var i=0;i<b.length;i++) b[i].classList.add('av-in','show'); }
      else seq(b);
      if(ms>=2){
        more.classList.add('gone');
        setTimeout(function(){ if(more.parentNode) more.remove(); }, 400);
      }
    });
  }

  var cj=document.getElementById('grCdJ'), cm=document.getElementById('grCdM'), cs=document.getElementById('grCdS');
  function pd(n){ return String(n).padStart(2,'0'); }
  function cd(){
    var now=new Date(), end=new Date(now);
    end.setHours(24,0,0,0);
    var d=end-now;
    if(cj) cj.textContent=pd(Math.floor(d/3600000));
    if(cm) cm.textContent=pd(Math.floor(d%3600000/60000));
    if(cs) cs.textContent=pd(Math.floor(d%60000/1000));
  }
  cd();
  setInterval(cd,1000);

  var sb=document.getElementById('grSbar');
  if(sb && 'IntersectionObserver' in window){
    var ho=false, fi=false;
    function upBar(){ sb.classList.toggle('show', ho && !fi); }
    var topEl=document.getElementById('grTop');
    var finEl=document.getElementById('grFin');
    if(topEl) new IntersectionObserver(function(es){ ho=!es[0].isIntersecting; upBar(); }, {threshold:0.05}).observe(topEl);
    if(finEl) new IntersectionObserver(function(es){ fi=es[0].isIntersecting; upBar(); }, {threshold:0.15}).observe(finEl);
  }

  var wrap=document.getElementById('grEb3d');
  if(wrap){
    var scene=document.getElementById('grEbScene');
    var pageEls=scene.querySelectorAll('.eb3d-page');
    var pages=[];
    for(var i=0;i<pageEls.length;i++) pages.push(pageEls[i]);
    var dots=document.getElementById('grEbDots');
    var ebHint=document.getElementById('grEbHint');
    var prevBtn=document.getElementById('grEbPrev');
    var nextBtn=document.getElementById('grEbNext');
    var order=[0,1,2];
    var pos=1;
    var lockAdded=false;
    var streak=0;
    var lastDir=0;
    var hinted=false;
    var dx=0;

    function layout(popLock){
      var total=order.length;
      var c=order[pos];
      var l=order[(pos-1+total)%total];
      var r=order[(pos+1)%total];
      for(var i=0;i<pages.length;i++){
        pages[i].classList.remove('is-l','is-c','is-r','is-back','is-pop');
        if(i===c){
          pages[i].classList.add('is-c');
          if(popLock && i===3 && !RD) pages[i].classList.add('is-pop');
        } else if(i===l) {
          pages[i].classList.add('is-l');
        } else if(i===r) {
          pages[i].classList.add('is-r');
        } else {
          pages[i].classList.add('is-back');
        }
      }
      if(dots){
        dots.innerHTML='';
        for(var j=0;j<order.length;j++){
          var el=document.createElement('b');
          var cls='';
          if(j===pos) cls+='on';
          if(order[j]===3) cls+=(cls?' ':'')+'lock';
          el.className=cls;
          dots.appendChild(el);
        }
      }
    }

    function step(dir){
      if(!dir) return;
      if(!hinted){
        hinted=true;
        if(ebHint) ebHint.classList.add('off');
      }
      if(!lockAdded){
        if(lastDir===dir) streak+=1;
        else { streak=1; lastDir=dir; }
        if(streak>=3){
          lockAdded=true;
          wrap.classList.add('has-lock');
          if(dir===1){ order.splice(pos+1, 0, 3); pos=pos+1; }
          else { order.splice(pos, 0, 3); }
          layout(true);
          if(ebHint){
            ebHint.textContent='Schalte das komplette E-Book frei';
            ebHint.classList.remove('off');
          }
          return;
        }
      }
      pos=(pos+dir+order.length)%order.length;
      layout(false);
    }

    layout(false);
    if(prevBtn) prevBtn.addEventListener('click', function(e){ e.stopPropagation(); step(-1); });
    if(nextBtn) nextBtn.addEventListener('click', function(e){ e.stopPropagation(); step(1); });
    for(var i=0;i<pages.length;i++){
      pages[i].addEventListener('click', function(e){
        if(Math.abs(dx)>12) return;
        if(e.target.closest('.js-co')) return;
        if(this.classList.contains('is-l')) step(-1);
        else if(this.classList.contains('is-r')) step(1);
      });
    }
    wrap.addEventListener('keydown', function(e){
      if(e.key==='ArrowLeft'){ e.preventDefault(); step(-1); }
      if(e.key==='ArrowRight'){ e.preventDefault(); step(1); }
    });

    var dragging=false, startX=0, startY=0, axis=null;
    function down(e){
      if(e.pointerType==='mouse' && e.button!==0) return;
      if(e.target.closest('.eb3d-nav') || e.target.closest('.js-co')) return;
      dragging=true; axis=null; dx=0;
      startX=e.clientX; startY=e.clientY;
      wrap.classList.add('is-hold');
    }
    function move(e){
      if(!dragging) return;
      var x=e.clientX-startX, y=e.clientY-startY;
      if(!axis && (Math.abs(x)>8 || Math.abs(y)>8)) axis = Math.abs(x)>Math.abs(y) ? 'x' : 'y';
      if(axis!=='x') return;
      dx=x;
      wrap.classList.add('is-drag');
      if(!RD) scene.style.transform='rotateY('+(dx*0.08)+'deg) rotateX(2deg)';
    }
    function up(){
      if(!dragging) return;
      dragging=false;
      wrap.classList.remove('is-drag','is-hold');
      scene.style.transform='';
      if(axis==='x' && Math.abs(dx)>36) step(dx<0 ? 1 : -1);
      dx=0; axis=null;
    }
    wrap.addEventListener('pointerdown', down);
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
  }
})();